

import { debounce } from "lodash";
import { useEffect } from "react";
import { useBreadcrumbState } from "../../store/breadcrumbState";
const format = require("string-template");

export const usePageContext = () => {
    const {
        selectedGroup,
        selectedProject,
        groups,
        projects,
        groupsLoading,
        projectsLoading,
        fetchGroups,
        fetchProjects,
        changeGroup,
        changeProject,
    
    } = useBreadcrumbState();





    const debouncedFetchGroups = debounce(fetchGroups, 300);

    const handleGroupSearchChange = (event: any) => {
        const searchQuery = event?.target?.value;
        
        if (searchQuery===undefined && event!==null) return 
        
        if (searchQuery){
        debouncedFetchGroups(searchQuery);
        } else {
        debouncedFetchGroups(null)
        }
    };

    
      const debouncedFetchProjects = debounce(fetchProjects, 300);
    
      const handleProjectSearchChange = (event: any) => {
        const searchQuery = event?.target?.value;
        if (searchQuery===undefined && event!==null) return 
        

        if (searchQuery) {
          debouncedFetchProjects(searchQuery);
        } else {
          debouncedFetchProjects()
        }
      };
   

    useEffect(() => {
        
        if(selectedGroup?.id) {
            
            handleProjectSearchChange(null)
        }
    }, [selectedGroup?.id]);



    
    return {
        handleGroupSearchChange,
        selectedGroup,
        selectedProject,
        groupsLoading,
        projectsLoading,
        handleProjectSearchChange,
        groups: groups|| [], 
        projects: projects|| [], 
        changeGroup, 
        changeProject
    };
};
